import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function LegalPage() {
  const loc = useLocation();
  const slug = loc.pathname.replace(/^\//, "") || "cgv";
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/legal/${slug}`).then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [slug]);

  return (
    <>
      <Header />
      <main className="pt-36 sm:pt-40 pb-20 min-h-screen bg-[#FAFAFA]" data-testid={`legal-page-${slug}`}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#06B6D4]">Textes légaux</div>
          <h1 className="display mt-3 text-3xl sm:text-4xl text-[#0A1128] font-extrabold">
            {data?.title || (slug === "cgv" ? "Conditions Générales de Vente" : slug === "mentions-legales" ? "Mentions légales" : "Politique de confidentialité")}
          </h1>
          {data?.updated_at && <div className="text-xs text-[#64748B] mt-1">Dernière mise à jour : {data.updated_at.slice(0, 10)}</div>}

          {loading ? (
            <div className="mt-8 text-sm text-[#64748B]">Chargement…</div>
          ) : (
            <article
              data-testid="legal-content"
              className="mt-8 bg-white rounded-3xl border border-black/8 p-6 sm:p-10 prose prose-sm sm:prose max-w-none prose-headings:font-extrabold prose-headings:text-[#0A1128] prose-a:text-[#06B6D4]"
              dangerouslySetInnerHTML={{ __html: data?.content_html || "<p>Page en cours de rédaction.</p>" }}
            />
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}
